import {otsBaseApi} from "../../ots-api";
import {TagCategory} from "../../../model/tag-category";

const ALL_TAG_TYPES = [
  "TagCategories",
  "TagDefinitionTagCategories",
  "ObjectObjectChangeLogs",
] as const;

type TagType = typeof ALL_TAG_TYPES[number];

const taggedBaseApi = otsBaseApi.enhanceEndpoints({
  addTagTypes: ALL_TAG_TYPES
});

export const tagCategoriesApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllTagCategories: builder.query<TagCategory[], void>({
      query: (arg) => ({
        url: `/tags/categories/all`,
        method: "GET",
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "TagCategories", id} as const)),
            {type: "TagCategories", id: "LIST"}
          ];
        } else {
          return [{type: "TagCategories", id: "LIST"}];
        }
      }
    }),
    getAllTagCategoriesByDefinition: builder.query<TagCategory[], string>({
      query: (arg) => ({
        url: `/tags/categories/all`,
        method: "GET",
        params: {
          tagDefinitionId: arg
        }
      }),
      providesTags: (result, error, arg) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "TagCategories", id} as const)),
            {type: "TagDefinitionTagCategories", id: arg}
          ];
        } else {
          return [
            {type: "TagDefinitionTagCategories", id: arg}
          ];
        }
      }
    }),
    getTagCategory: builder.query<TagCategory, string>({
      query: (id) => ({
        url: `/tags/categories/${id}`,
        method: "GET"
      }),
      providesTags: (result, error, id) => [{type: "TagCategories", id}]
    }),
    createTagCategory: builder.mutation<TagCategory, Partial<TagCategory>>({
      query: (mapping) => ({
        url: "/tags/categories",
        method: "POST",
        body: mapping
      }),
      invalidatesTags: [
        {type: "TagCategories", id: "LIST"},
      ]
    }),
    updateTagCategory: builder.mutation<TagCategory, Partial<TagCategory>>({
      query: (arg) => ({
        url: `/tags/categories`,
        method: "PUT",
        body: arg,
      }),
      invalidatesTags: (result, error, {id}) => [
        {type: "TagCategories", id},
        {type: "ObjectObjectChangeLogs", id},
        {type: "TagCategories", id: "LIST"},
        {type: "TagDefinitionTagCategories"},
      ]
    }),
    deleteTagCategory: builder.mutation<void, Partial<TagCategory>>({
      query: (mapping) => ({
        url: "/tags/categories",
        method: "DELETE",
        body: mapping
      }),
      invalidatesTags: (result, error, {id}) => [
        {type: "TagCategories", id},
        {type: "TagCategories", id: "LIST"},
        {type: "TagDefinitionTagCategories"},
      ]
    }),
  })
});

export const {
  useGetAllTagCategoriesQuery,
  useGetAllTagCategoriesByDefinitionQuery,
  useGetTagCategoryQuery,
  useCreateTagCategoryMutation,
  useUpdateTagCategoryMutation,
  useDeleteTagCategoryMutation,
} = tagCategoriesApi;
